import React from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import BaseTourViewer from "./BaseTourViewer";

function Index({ email, token, isPublic = false }) {
  const location = useLocation();
  const { project, date } = location.state || {};

  return (
    <>
      <BaseTourViewer
        project={project}
        date={date}
        email={email}
        token={token}
        isPublic={isPublic}
      />
    </>
  );
}

const mapStateToProps = state => ({
  email: state.auth.email,
  token: state.auth.accessToken
});

export default connect(mapStateToProps)(Index);
